import _ from 'lodash';
import { getCommitStatsSucceed, getCommitStatsFailure } from '../actions';
import { getCommitStats as getCommitStatsApi } from 'common/services/commit-stats.service';

export const getCommitStats = (paramsList = []) => async dispatch => {
  try {
    const response = await Promise.all(paramsList.map(getCommitStatsApi));
    dispatch(getCommitStatsSucceed(_.flattenDeep(response)));
  } catch (e) {
    dispatch(getCommitStatsFailure());
  }
};
